<div class="container-fluid widget-wrapper">
  <div class="row widget-header" #widgetHeader [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2><span>Developer Overview</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon" data-placement="top" data-toggle="tooltip" enTooltip title="Essential information about the app's developer">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon"/>
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-publisher-overview [data]="data" [os]="os" [device]="device"
                              [region]="region" [isFollowing]="isFollowing" [isFreemium]="isFreemium"
                              (anchorClick)="anchorClick.emit($event)" (followClick)="followButtonClick.emit()"
                              (toAppDiscovery)="toAppDiscovery.emit($event)"></app-publisher-overview>
    </div>
  </div>
</div>
